'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$filter", "TimeZoneFactory", function ($filter, TimeZoneFactory) {

    function MessageDescriptorFactory() {

    }
    MessageDescriptorFactory.prototype.createMessageQueryParams = function (trainId, projectId, from, to, rate, aggregate) {

        //incoming dates are in system timezone. Eg. Brussels: GMT+2.
        //formatting to UTC ( +00:00)
        // 10:00:00 GMT+2 --> 08:00:00 +00:00
        var period = TimeZoneFactory.formatUtcToBackendPeriod(from, to);

        var params = {
            'trainId': trainId,
            'projectId': projectId,
            'from': period.start,
            'to': period.end,
            'rate': util.isDefined(rate) ? rate : 1
        };

        if (util.isDefined(aggregate) && aggregate) {
            params.aggregate = true;
        }
        return params;
    };

    return new MessageDescriptorFactory();
}];
